export const getInitials = (firstName?: string | null, lastName?: string | null) => {
  let initials = "";

  if (firstName) {
    initials += firstName[0].toUpperCase();
  }

  if (lastName) {
    initials += lastName[0].toUpperCase();
  }

  return initials;
};

export const getFullName = (firstName?: string | null, lastName?: string | null) => {
  let name = "";

  if (firstName) {
    name += firstName;
  }

  if (lastName) {
    name += ` ${lastName}`;
  }

  return name;
};
